import { fetchAssets } from '@/api/asset';

export const state = {
	assets: [],
	registedAssets: [],
};

export const mutations = {
	SET_ASSET_LIST(state, value) {
		state.assets = value;
	},
	SET_REGISTED_ASSET_LIST(state, value) {
		state.registedAssets = value;
	},
};

export const getters = {
	assets(state) {
		return state.assets;
	},
	registedAssets(state) {
		return state.registedAssets;
	},
};

export const actions = {
	init({ dispatch }) {
		dispatch('getAssets');
	},
	async getAssets({ commit }) {
		const { data } = await fetchAssets({
			no_paging: 1,
		});
		commit(
			'SET_ASSET_LIST',
			data.filter(item => item.is_active === 'Y'),
		);
		commit('SET_REGISTED_ASSET_LIST', data);
		return data;
	},
};
